<template>
  <el-dialog
    class="login-dialog"
    :show-close="false"
    :visible.sync="$store.getters.isShowLoginDialog"
    :before-close="handleClose"
  >
    <el-row class="dialog-form-login">
      <el-form ref="loginForm" :model="loginForm" class="login-form">
        <div>
          <img
            @click="handleClose"
            style="position: absolute; top: 0px; right:0;z-index:1000"
            :src="icons.CloseIcon"
            alt=""
          />
        </div>
        <div class="title-container">
          <h3 class="title mt-10">Login</h3>
        </div>
        <div
          style="text-align: center; padding: 0 ; margin: 0;"
          class="logoContainer"
        >
          <img
            style="padding: 0; margin: 0; width:200px"
            :src="icons.Logo"
            alt=""
          />
          <!-- <p style="color: #035AE0" class="fw-700 c-title1">Edufarm</p> -->
        </div>
        <div
          style="display: flex; justify-content: center;position: absolute; top: 165px; left:44%;z-index:9999999;"
        >
          <img
            @click="handleLogin(4)"
            class="mr-10"
            :src="icons.GoogleIcon"
            alt=""
          />
          <!-- <img @click="handleLoginFb(1)" :src="icons.FbIcon" alt="" /> -->
        </div>
        <div style="margin-top: 55px;">
          <p style="margin: 0; padding: 0; text-align: center;">
            Can't login? Contact us
          </p>
          <!-- <p style="text-align: center;">
            Contact us
          </p> -->
          <div
            style="display: flex; justify-content: center; margin-top: 10px;"
          >
            <a href=" https://t.me/+9xD_UHwNiOM0NTg9">
              <img :src="icons.SocialZaloIcon" alt=""
            /></a>
            <a href="mailto:freestyle.myapp@gmail.com">
              <img class="mr-10 ml-10" :src="icons.PhoneIcon" alt="" />
            </a>
            <a href="https://www.facebook.com/people/Hocvivu/61561372160944/">
              <img  :src="icons.FaceBookIcon" alt="" />
            </a>
          </div>
        </div>
      </el-form>
    </el-row>
  </el-dialog>
</template>

<script>
import AuthResource from "@/views/api/auth.js";
import { setInfo, setToken, setRefreshToken } from "../../utils/auth";
import Logo from "@/assets/img/logo/logo.svg";
import LogoIcon from "@/assets/img/Gmaths.vn.png";
import UserIcon from "@/assets/img/svg/user.svg";
import PassIcon from "@/assets/img/svg/password.svg";
import FbIcon from "@/assets/img/svg/facebook_icon.svg";
import AppleIcon from "@/assets/img/svg/apple_icon.svg";
import GoogleIcon from "@/assets/img/svg/google_icon.svg";
import SocialMessengerIcon from "@/assets/img/svg/social-messenger.svg";
import SocialZaloIcon from "@/assets/img/svg/telegram-svgrepo-com.svg";
import PhoneIcon from "@/assets/img/svg/email-8-svgrepo-com.svg";
import CloseIcon from "@/assets/img/svg_edu/CloseIcon.svg";
import FaceBookIcon from "@/assets/img/svg/facebook-svgrepo-com.svg";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithRedirect,
  getRedirectResult
} from "firebase/auth";
export default {
  name: "LoginDialog",
  data() {
    return {
      islock: false,
      isMobile: false,
      loadingSubmit: false,
      loginForm: {
        phone: "",
        password: ""
      },
      loading: false,
      redirect: undefined,
      otherQuery: {},
      isLogin: false,
      phoneInput: "",
      icons: {
        CloseIcon,
        Logo,
        LogoIcon,
        UserIcon,
        PassIcon,
        FbIcon,
        AppleIcon,
        GoogleIcon,
        SocialMessengerIcon,
        SocialZaloIcon,
        PhoneIcon,
        FaceBookIcon
      }
    };
  },
  computed: {},
  watch: {
    "$store.getters.isShowLoginDialog"(value) {
      document.documentElement.style.overflow = "hidden";
      if (value) {
        console.log(window.location.hostname);
        if (
          this.$store.getters.isMobile &&
          !this.$store.getters.isBlockPopup &&
          window.location.hostname !== "localhost"
        ) {
          this.$store.dispatch("setBlockPopup", true);
          try {
            this.$store.dispatch("loginGG");
            console.log("token_______", token);
          } catch (error) {
            console.log(error);
          }
        }
        this.isLogin = false;
        this.loginForm = {
          phone: "",
          password: ""
        };
      } else {
        document.documentElement.style.overflow = "auto";
      }
    },
    phoneInput(value) {
      this.loginForm.username = value;
    }
  },
  $route: {
    handler: function(route) {
      const query = route.query;
      if (query) {
        this.redirect = query.redirect;
      }
    },
    immediate: true
  },
  created() {},
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    //this.handleRedirectResult(4);
  },
  beforeDestroy() {
    console.log("vao day reset reszise");
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // Cập nhật giá trị chiều rộng màn hình khi sự kiện resize xảy ra
      const currentWidth = window.innerWidth;
      if (currentWidth < 770) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
      this.$store.dispatch("user/setIsMobile", this.isMobile);
    },
    async handleLogin(provider_id_number) {
      this.handleLoginGG(provider_id_number);
      return;
      if (this.isMobile) {
        this.handleLoginGGRedirect();
      } else {
        this.handleLoginGG(provider_id_number);
      }
    },
    async handleLoginGG(provider_id_number) {
      try {
        const access_token = await this.$store.dispatch("loginGG");
        console.log("access_token__________", access_token);
        const body = {
          provider_id_number,
          login_type: 2,
          access_token
        };
        this.login(body);
        // return
        // const auth = getAuth(); // Lấy đối tượng auth từ Firebase
        // const provider = new GoogleAuthProvider(); // Tạo một provider cho đăng nhập bằng Google
        // // Mở popup đăng nhập bằng Google
        // signInWithPopup(auth, provider)
        //   .then(result => {
        //     console.log("result_________", result);
        //     const body = {
        //       provider_id_number,
        //       login_type: 2,
        //       access_token: result.user.accessToken
        //     };
        //     this.login(body);
        //     // Đăng nhập thành công, bạn có thể xử lý dữ liệu người dùng ở đây
        //     console.log("User:", result.user.accessToken);
        //   })
        //   .catch(error => {
        //     console.log("errro________", error);
        //   });
      } catch (error) {
        console.error("Đăng nhập thất bại:", error.message);
      }
    },
    async handleLoginGGRedirect() {
      try {
        const auth = getAuth(); // Lấy đối tượng auth từ Firebase
        const provider = new GoogleAuthProvider(); // Tạo một provider cho đăng nhập bằng Google
        // Mở popup đăng nhập bằng Google
        signInWithRedirect(auth, provider)
          .then(result => {
            console.log("result_________", result);
          })
          .catch(error => {
            console.log("errro________", error);
          });
      } catch (error) {
        console.error("Đăng nhập thất bại:", error.message);
      }
    },
    async handleRedirectResult(provider_id_number) {
      try {
        const auth = getAuth(); // Lấy đối tượng auth từ Firebase
        const result = await getRedirectResult(auth);
        this.$message.error(JSON.stringify(result));
        if (result) {
          console.log("result_________", result);
          const body = {
            provider_id_number,
            login_type: 2,
            access_token: result.user.accessToken
          };
          this.login(body);
          // Đăng nhập thành công, bạn có thể xử lý dữ liệu người dùng ở đây
          console.log("User:", result.user.accessToken);
        }
      } catch (error) {
        this.$message.error(error);
        console.log("errro________", error);
      }
    },
    handleLoginFb(provider_id_number) {
      const body = {
        provider_id_number,
        login_type: 2,
        access_token: ""
      };
      FB.login(
        loginResponse => {
          if (loginResponse.authResponse) {
            // Người dùng đã đăng nhập thành công, lấy access token
            var accessToken = loginResponse.authResponse.accessToken;
            console.log("Access token:", accessToken);
            body.access_token = accessToken;
            this.login(body);
          } else {
            // Người dùng không đăng nhập
            console.log("Người dùng không đăng nhập");
          }
        },
        { scope: "email" }
      ); // scope là các quyền bạn muốn yêu cầu từ người dùng
      // // Phương thức để đăng nhập bằng Facebook
      // FB.getLoginStatus((response) => {
      //   if (response.status !== "connected") {
      //     // Nếu người dùng chưa đăng nhập, mở popup đăng nhập
      //     FB.login(
      //       (loginResponse) => {
      //         if (loginResponse.authResponse) {
      //           // Người dùng đã đăng nhập thành công, lấy access token
      //           var accessToken = loginResponse.authResponse.accessToken;
      //           console.log("Access token:", accessToken);
      //           body.access_token = accessToken
      //           this.login(body)
      //         } else {
      //           // Người dùng không đăng nhập
      //           console.log("Người dùng không đăng nhập");
      //         }
      //       },
      //       { scope: "email" }
      //     ); // scope là các quyền bạn muốn yêu cầu từ người dùng
      //   } else {
      //     // Người dùng đã đăng nhập, bạn có thể lấy access token từ response.authResponse.accessToken
      //     var accessToken = response.authResponse.accessToken;
      //     console.log("Access token:", accessToken);
      //     body.access_token = accessToken
      //     this.login(body)
      //   }
      // });
    },
    login(body) {
      this.loading = true;
      AuthResource.login(body)
        .then(res => {
          if (res.error_code === 0) {
            this.$store.dispatch("hideLoginDialog");
            console.log("....................login", res.data);
            const { token, ...rest } = res.data;
            const body = {
              ...rest,
              token: token.access_token
            };
            setInfo(body);
            setToken(token.access_token);
            setRefreshToken(token.refresh_token);
            window.location.reload();
          } else {
            this.$message.error(
              res.error_msg || " Có lỗi sảy ra, Vui lòng thử lại sau"
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose(e) {
      // if (!getToken()) {
      //   return;
      // }
      this.$store.dispatch("hideLoginDialog");
      // this.loginForm = {
      //   phone: "",
      //   code: ""
      // };
      // this.phoneInput = "";
      // this.$refs.loginForm.clearValidate();
      this.isLogin = false;
    }
  }
};
</script>
<style>
.login-dialog .el-dialog {
  position: relative;
  border-radius: 24px;
  background: #efefef;
  max-width: 450px !important;
  width: 100%;
  min-width: 300px !important;
}
.login-dialog .el-dialog .el-dialog__header {
  padding: 0;
}
</style>
<style lang="scss">
$bg: #fff;
$light_gray: #fff;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
}

/* reset element-ui css */
.dialog-form-login {
  .el-form-item {
    border: 1px solid rgb(206, 205, 205);
    border-radius: 5px;
  }
}
</style>

<style lang="scss" scoped>
$bg: #fff;
$dark_gray: #eee;
$light_gray: #eee;
.el-dialog {
  width: 30%;
}
.dialog-form-login {
  overflow: hidden;

  .login-form {
    position: relative;
    width: 400px;
    max-width: 100%;
    padding: 0 20px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      margin: 10px auto 20px auto;
      text-align: center;
      font-weight: 700;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
    .el-dialog {
      width: 100%;
    }
  }

  .icon {
    font-size: 24px;
    padding: 0px;
    color: #3c485c;
    background-color: transparent;
    border-color: transparent;
  }
}
</style>
